import { render } from "./OffCanvasWebsiteMenu.vue?vue&type=template&id=16baa388"
import script from "./OffCanvasWebsiteMenu.vue?vue&type=script&lang=js"
export * from "./OffCanvasWebsiteMenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Documents\\MetaLuxe\\projects\\website-template\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__